import styled from 'styled-components';
import { fontHeadingMd } from '../../typography.styled';

export const CompUnit = styled.div`
    display: flex;
    flex-wrap: nowrap;

    span {
        ${fontHeadingMd};
        white-space: nowrap;
        padding-top: 30px;
    }
`;
